import React, { useState } from 'react';
import styled from 'styled-components';
import BoostFloralLogo from '../../../app/components/svgIcons/BoostFloralLogo';
import { Link, NavLink } from 'react-router-dom';
import ButtonArrowIcon from '../assets/svg/ButtonArrowIcon';
import BoostFloralMobileIcon from '../../../app/components/svgIcons/BoostFloralMobileIcon';

const Menu = styled.ul`
  display: flex;
  list-style: none;
  margin: 0;
`;

const MenuItem = styled.li`
  text-decoration: none;
  color: ${({ theme }) => theme.primary};
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  position: relative;
  transition: transform 0.3s;

  color: var(--gray-900, #18181b);

  font-family: Instrument Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 5px;
    background-color: ${({ theme }) => theme.primary};
    transition: width 0.3s;
  }

  &:hover::before {
    width: 100%;
  }

  &.active::before {
    width: 100%;
  }

  &:not(:last-child) {
    margin-right: 20px;
  }
`;

const menuItems = [
  { title: 'Home', url: '/', as: 'a' },
  { title: 'Features', url: '/features', as: 'a' },
  { title: 'Pricing', url: '/pricing', as: 'a' },
  { title: 'Florist Websites', url: '/florist-websites', as: 'a' },
  { title: 'Comparison', url: '/comparison', as: 'a' },
  { title: 'Contact', url: '/contact', as: 'a' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <NavBarContianer>
      <a href="/">
        <div className="desktop">
          <BoostFloralLogo />
        </div>
        <div className="mobile">
          <BoostFloralMobileIcon />
        </div>
      </a>

      <div className=" d-flex align-items-center gap-2 gap-lg-3">
        <div className="desktop">
          <Menu>
            {menuItems.map((item) => (
              <MenuItem
                key={item.title}
                as={item.as}
                activeclassname="active"
                {...(item.as === 'a' ? { href: item.url } : { to: item.url })}
              >
                {item.title}
              </MenuItem>
            ))}
          </Menu>
        </div>

        <Link className="desktop text-decoration-none" to="/login">
          <StyledTextButton>Log In</StyledTextButton>
        </Link>

        {!open && (
          <Link className="text-decoration-none" to="/signup">
            <StyledButton>
              Start For Free <ButtonArrowIcon color="#FFFFFF" />
            </StyledButton>
          </Link>
        )}

        <div className="mobile">
          <div className="mobile-dropdown">
            <div
              className="mobile-dropdown-toggle"
              onClick={() => setOpen((state) => !state)}
            >
              {!open ? (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.28307 19L20 19M19.9996 12L4 12M20 5L12.9719 5"
                    stroke="#1A0425"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.35288 8.95043C4.00437 6.17301 6.17301 4.00437 8.95043 3.35288C10.9563 2.88237 13.0437 2.88237 15.0496 3.35288C17.827 4.00437 19.9956 6.17301 20.6471 8.95044C21.1176 10.9563 21.1176 13.0437 20.6471 15.0496C19.9956 17.827 17.827 19.9956 15.0496 20.6471C13.0437 21.1176 10.9563 21.1176 8.95044 20.6471C6.17301 19.9956 4.00437 17.827 3.35288 15.0496C2.88237 13.0437 2.88237 10.9563 3.35288 8.95043Z"
                    stroke="#1A0425"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M13.768 10.2305L10.2324 13.766M13.768 13.766L10.2324 10.2305"
                    stroke="#1A0425"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              )}
            </div>
            <DropdownMenu open={open}>
              {menuItems.map((item, index) => (
                <Link key={index} className="item" to={item.url ?? '#'}>
                  <p>{item.title}</p>
                </Link>
              ))}
              <div className="button-container">
                <Link className="text-decoration-none w-100" to="/signup">
                  <StyledButton className="w-100">
                    Start For Free <ButtonArrowIcon color="#FFFFFF" />
                  </StyledButton>
                </Link>
                <Link to={'/login'} className="login">
                  <p>Already have an account?</p>{' '}
                  <span className="login-text">Login</span>
                </Link>
              </div>
            </DropdownMenu>
          </div>
        </div>
      </div>
    </NavBarContianer>
  );
};

const NavBarContianer = styled.nav`
  padding: 1.5rem 6.25rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 100;
  background: var(--BG-Color, #f2f2f2);

  .mobile {
    display: none;
  }

  desktop {
    display: block;
  }

  .mobile-dropdown-toggle {
    cursor: pointer;
  }

  .mobile-dropdown {
    position: relative;
  }

  @media screen and (max-width: 1024px) {
    padding: 1.5rem 2.25rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: sticky;
    top: 0;
    z-index: 100;
    background: var(--BG-Color, #f2f2f2);

    .mobile {
      display: none;
    }

    desktop {
      display: block;
    }

    .mobile-dropdown-toggle {
      cursor: pointer;
    }

    .mobile-dropdown {
      position: relative;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 1rem 1.25rem;
    height: 80px;
    justify-content: space-between;

    .mobile {
      display: block;
    }

    .desktop {
      display: none;
    }
  }
`;

const StyledButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 19px 32px;
  border-radius: 8px;
  border: none;
  background: var(--secoundary-secoundary-500-f, #cb1d8d);
  color: var(--font-color-font-4, #fff);
  text-align: center;
  font-family: Instrument Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;

  @media screen and (max-width: 1024px) {
    padding: 16px 24px;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
  }

  @media screen and (max-width: 768px) {
    padding: 12px 16px;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
  }
`;

const StyledTextButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 19px 32px;
  border: none;
  background: transparent;
  color: var(--font-color-font-1, #1b131f);
  text-align: center;
  font-family: Instrument Sans;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;

  @media screen and (max-width: 1024px) {
    padding: 16px 24px;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
  }
`;

const DropdownMenu = styled.div`
  display: ${({ open }) => (open ? 'block' : 'none')};
  position: fixed;
  top: 70px;
  right: 0;
  left: 0;
  background: var(--BG-Color, #f2f2f2);
  padding: 1.5rem 0;

  .item {
    display: flex;
    padding: 16px 20px;
    align-items: center;
    gap: 4px;
    align-self: stretch;
    color: var(--gray-900, #18181b);

    font-family: Instrument Sans;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  .button-container {
    display: flex;
    padding: 0px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    margin-top: 1.5rem;

    .login {
      color: var(--font-color-font-1, #1b131f);
      text-align: center;
      font-family: Instrument Sans;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      display: flex;
      width: 100%;
      justify-content: center;
      gap: 10px;
      align-items: center;

      p {
        margin: 0;
      }
    }

    .login-text {
      color: var(--secoundary-secoundary-500-f, #cb1d8d);
      font-family: Instrument Sans;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
    }
  }
`;

export default Navbar;
